module.exports = __webpack_public_path__ + "img/gb14.prt.a0167706.jpg";